__turbopack_context__.v({
  "fade-in": "StaticMap-module-scss-module__DZ2biW__fade-in",
  "map": "StaticMap-module-scss-module__DZ2biW__map",
  "mapWrapper": "StaticMap-module-scss-module__DZ2biW__mapWrapper",
  "message": "StaticMap-module-scss-module__DZ2biW__message",
  "no-transform": "StaticMap-module-scss-module__DZ2biW__no-transform",
  "rotate": "StaticMap-module-scss-module__DZ2biW__rotate",
});
